import React from 'react';
import BreadcrumbContext from './BreadcrumbContext';
import withBreadcrumbs from '../withBreadcrumbs';
class AnchorContent extends React.Component {
    constructor(props) {
        super(props);
        const { depth, title, route, hasQuickLinkButton } = props;
        this.state = { depth, title, route, hasQuickLinkButton };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const { depth, title, route, hasQuickLinkButton } = prevState;
        const { depth: nextDepth, title: nextTitle, route: nextRoute, hasQuickLinkButton: nextHasQuickLinkButton, } = nextProps;
        if (depth !== nextDepth ||
            title !== nextTitle ||
            route !== nextRoute ||
            hasQuickLinkButton !== nextHasQuickLinkButton) {
            return {
                depth: nextDepth,
                title: nextTitle,
                route: nextRoute,
                hasQuickLinkButton: nextHasQuickLinkButton,
            };
        }
        return null;
    }
    componentDidMount() {
        this.props.addAnchor({ ...this.state });
    }
    componentDidUpdate(prevProps, prevState) {
        const { addAnchor, updateAnchor, removeAnchor } = this.props;
        const { route, title, depth, hasQuickLinkButton } = this.state;
        const { route: prevRoute, title: prevTitle, depth: prevDepth, hasQuickLinkButton: prevHasQuickLinkButton, } = prevState;
        if (!route.includes(prevRoute)) {
            removeAnchor(prevRoute);
            addAnchor({ route, title, depth, hasQuickLinkButton });
        }
        else if (title !== prevTitle ||
            depth !== prevDepth ||
            hasQuickLinkButton !== prevHasQuickLinkButton) {
            updateAnchor({ route, title, depth, hasQuickLinkButton });
        }
    }
    componentWillUnmount() {
        const { route } = this.state;
        this.props.removeAnchor(route);
    }
    render() {
        const { children } = this.props;
        const { depth } = this.state;
        return (<BreadcrumbContext.Provider value={{ depth: depth + 1 }}>
        {children}
      </BreadcrumbContext.Provider>);
    }
}
export default withBreadcrumbs(AnchorContent);
